namespace SorAraBul.Administration {
    export namespace UserCreditService {
        export const baseUrl = 'Administration/UserCredit';

        export declare function GetCredit(request: Serenity.ServiceRequest, onSuccess?: (response: Web.Modules.Administration.User.RequestHandlers.GetCreditResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            GetCredit = "Administration/UserCredit/GetCredit"
        }

        [
            'GetCredit'
        ].forEach(x => {
            (<any>UserCreditService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
